import React from 'react';

export const Divider = () => {
	return <hr className="divider" />;
};
